import Shipments from "../../../containers/shipments/shipments";
import { getApiUrl } from "../../../utils/baseUrl";
import { filterTypeDictionary as filterType, analyticsTypeDictionary as analyticsType, autoSuggestLanguageDictionary as autosuggestLanguageOptions, categoryType } from "../../../core/global/global-country-dictionary";
import { globalCountryDetailsDictionary as globalCountryDetails } from "../../../core/global/global-country-details";

export const analyticDropdownOptions = [
  { value: "shipments", label: "Number of Shipments", two_table_header: "Total Shipments" },
  { value: "weight", label: "Total Weight", two_table_header: "Total Weight (kg)" },
  { value: "value", label: "Shipment Value (USD)", two_table_header: "Total Value (USD)" },
];
export const trendsDropdownOptions = [
  { value: "shipments", label: "Shipments", table_header: "Total Shipments" },
  { value: "weight", label: "Weight (kg)", table_header: "Total Weight (kg)" },
  { value: "value", label: "Value (USD)", table_header: "Total Value (USD)" },
];
export const defaultData = {
  name: "Ethiopia Imports",
  showFacilityFilter: true,
  customShipmentGrid: true,
  showUiUeLevelTwo: true,
  isProductChemicalPresent: true,
  analyticsRangeDownloadPresent: true,
  isShipmentGridNew: true,
  isBooleanFilter: true,
  isUIGridNew: true,
  isUEGridNew: true,
  isViewAllGridNew: true,
  changedPayloadForExcel: true,
  autosuggestLang: "ET",
  isHandleTrademoAccount: true,
  isImpExpGraph: true,
  showUiTrends: true,
  showTwoLevel: true,
  analyticsDefault: analyticDropdownOptions[1].value,
  isFilterGroupingPresent: true,
  exportPDFInAnalytics: false,
  minimumDateAllowed: "2014-01-01",
  trendsTableCompanyID: {
    shipper: "hashed_id",
    consignee: "hashed_id",
  },
  importer_exporter_graph_sort__options: [
    { value: "doc_count", value1: "date", label: "Shipments", table_header: "Total Shipments" },
    { value: "weight", label: "Weight (kg)", table_header: "Total Weight (kg)" },
    { value: "shipment_value", label: "Value (USD)", table_header: "Total Value (USD)" },
  ],
  apiEndPoints: {
    getArrivalDate: getApiUrl("getLatestArrivalDate"),
    getSearchResult: getApiUrl("intelSearchEthiopiaImport"),
    getAnalyticsData: getApiUrl("analytics/intelAnalyticsEthiopiaImport"),
    saveProspectiveExportersApi: "addFavouriteCompany",
    saveProspectiveImportersApi: "addFavouriteCompany",
    downloadShipmentsApi: getApiUrl("create_excel_ethiopia_imports"),
    downloadUniqueImporterExporter: getApiUrl("create_excel_ethiopia_imports"),
    getShipmentByID: getApiUrl("intelSearchEthiopiaImportShipmentByID"),
    getShipmentDownloadData: getApiUrl("renderToPdfEthiopiaImports"),
    renderToPdfAnalytics: getApiUrl("renderToPdfAnalytics"),
    getUserPlanDetails: getApiUrl("getUserCreditsByPlan"),
    getCompanySlug: getApiUrl("companyProfiles/getSlug"),
    getSavedSearchPayloadById: getApiUrl("getSavedSearchPayloadById"),
    getMasterListsForAutoSearchFeilds: getApiUrl("dashboard/getMasterListsForAutoSearchFeilds"),
    getAnalyticsViewAll: getApiUrl("analytics/intelAnalyticsEthiopiaImportViewAll"),
    getMissingTabData: getApiUrl("intelSearchWhatAreMissing"),
    getImpExpGraphData: getApiUrl("intelSearchEthiopiaImportGraph"),
  },
  isAdvancedSearchAvailable: true,
  country_small: globalCountryDetails.et_import.country_small,
  countryCaps: globalCountryDetails.et_import.country_caps,
  product_id: globalCountryDetails.et_import.product_id,
  compare_product_id: globalCountryDetails.et_import.compareProduct,
  country_CamelCase: globalCountryDetails.et_import.product_id,
  countryCode: globalCountryDetails.et_import.countryCode,
  countryType: globalCountryDetails.et_import.countryType,
  manyCountryType: globalCountryDetails.et_import.manyCountryType,
  countryTypeCode: globalCountryDetails.et_import.countryTypeCode,
  redirectionID: globalCountryDetails.et_import.redirectionID,
  analyticsCountryID: globalCountryDetails.et_import.analyticsCountryID,
  autoSuggestLanguage: autosuggestLanguageOptions.english,
  dateRangeHeading: "Shipments Arrival Date Range",
  monthRangeHeading: "Month of Export",
  picker: {
    monthPicker: false,
    datePicker: true,
  },
  tabKeyWords: {
    shipments: true,
    analytics: true,
    importers: true,
    whatYouAreMissing: true,
  },
  main_dropdown_options: {
    entire_bill_of_lading: false,
    product_description: true,
    product_hscode: true,
    exporters: true,
    importers: true,
    allCategory: true,
    ports: true,
    product_category: true,
    chemical_description: true,
  },
  searchCategoryList: globalCountryDetails.et_import.defaultDropDown,
  specialFields: {
    hscode: "hsCode",
    consignee: "derivedConsigneeMasterName",
    shipper: "derivedShipperMasterName",
    weight: "weight",
    value: "shipmentValue",
    proximity: "buyerZipCode",
    productCategory: "productCategory",
    sixDigitHsCode: "sixDigitHsCode",
    portOfLading: "standardLadingPortRegion",
    portOfUnlading: "standardUnladingPortRegion",
    vocc: "standardVoccName",
    nvocc: "standardNvoccName",
    freightForwarder: "standardFreightForwarderName",
    tradeLane: "standardTradeLane",
  },
  filterObj: {
    billType: "billType",
    include_master_bill: "include_master_bill",
    buyerCity: "buyerCity",
    buyerState: "buyerState",
    buyerZipCode: "buyerZipCode",
    carrierName: "carrierName",
    countryOfImportRegion: "countryOfImportRegion",
    countryOfExportRegion: "countryOfExportRegion",
    consigneeJurisdictionCountryRegion: "consigneeJurisdictionCountryRegion",
    consigneeCountry: "consigneeCountry",
    containerType: "containerType",
    countryRegion: "countryRegion",
    equipmentDescription: "equipmentDescription",
    exporters: "exporters",
    is_supplier: "is_supplier",
    is_buyer: "is_buyer",
    isImporter: "isImporter",
    consigneeName: "consigneeName",
    foreignPort: "foreignPort",
    foreignPortRegion: "foreignPortRegion",
    hsCode: "hsCode",
    importers: "importers",
    lclFCL: "lclFCL",
    noOfUniqueContainers: "noOfUniqueContainers",
    notifyParty: "notifyParty",
    secondaryNotifyParties: "secondaryNotifyParties",
    standardNvoccName: "standardNvoccName",
    standardFreightForwarderName: "standardFreightForwarderName",
    portOfArrival: "portOfArrival",
    portOfDestination: "portOfDestination",
    portOfDestinationRegion: "portOfDestinationRegion",
    standardUnladingPortName: "standardUnladingPortName",
    standardUnladingPortRegion: "standardUnladingPortRegion",
    vesselType: "vesselType",
    vesselTypeRegion: "vesselTypeRegion",
    stateRegion: "stateRegion",
    supplierCountry: "supplierCountry",
    transportation: "transportation",
    typeOfService: "typeOfService",
    standardVoccName: "standardVoccName",
    weight: "weight",
    shipmentValue: "shipmentValue",
    shipperFacility: "shipperFacility",
    consigneeFacility: "consigneeFacility",
    derivedShipperMasterName: "derivedShipperMasterName",
    derivedConsigneeMasterName: "derivedConsigneeMasterName",
    productCategory: "productCategory",
    industryCategory: "industryCategory",
    shipperCity: "shipperCity",
    sixDigitHsCode: "sixDigitHsCode",
    standardLadingPortName: "standardLadingPortName",
    standardLadingPortRegion: "standardLadingPortRegion",
    containerDimensionRegion: "containerDimensionRegion",
    containerDescriptionRegion: "containerDescriptionRegion",
    standardTradeLane: "standardTradeLane",
    vesselName: "vesselName",
    quantityUnit: "quantityUnit",
    perUnitValue: "perUnitValue",
    quantityRange: "quantityRange",
  },
  booleanFilterObj: {
    include_master_bill: "include_master_bill",
    exclude_blank_consignee: "exclude_blank_consignee",
    exclude_blank_shipper: "exclude_blank_shipper",
  },
  boxRangeFilterList: {
    noOfUniqueContainers: "noOfUniqueContainers",
    weight: "weight",
    shipmentValue: "shipmentValue",
    perUnitValue: "perUnitValue",
    quantityRange: "quantityRange",
  },
  boxFilterObj: {
    noOfUniqueContainers: [],
    weight: [],
    shipmentValue: [],
    perUnitValue: [],
    quantityRange: [],
  },
  localisationFilterObj: {
    countryOfImportRegion: "countryOfImport",
    countryOfExportRegion: "countryOfExport",
    consigneeJurisdictionCountryRegion: "consigneeJurisdictionCountry",
    countryRegion: "supplierCountry",
    stateRegion: "buyerState",
    standardUnladingPortRegion: "standardUnladingPortName",
    portOfDestinationRegion: "portOfDestination",
    foreignPortRegion: "foreignPort",
    vesselTypeRegion: "vesselType",
    standardLadingPortRegion: "standardLadingPortName",
    containerDimensionRegion: "containerDimension",
    containerDescriptionRegion: "containerDescription",
  },
  emptyFilterObj: {
    billType: [],
    buyerCity: [],
    buyerState: [],
    buyerZipCode: [],
    carrierName: [],
    countryOfImportRegion: [],
    countryOfExportRegion: [],
    consigneeJurisdictionCountryRegion: [],
    consigneeCountry: [],
    containerType: [],
    countryRegion: [],
    equipmentDescription: [],
    exporters: [],
    is_supplier: [],
    is_buyer: [],
    isImporter: [],
    consigneeName: [],
    foreignPort: [],
    foreignPortRegion: [],
    hsCode: [],
    importers: [],
    lclFCL: [],
    vesselName: [],
    noOfUniqueContainers: [],
    notifyParty: [],
    secondaryNotifyParties: [],
    standardNvoccName: [],
    standardFreightForwarderName: [],
    portOfArrival: [],
    portOfDestination: [],
    portOfDestinationRegion: [],
    standardUnladingPortName: [],
    standardUnladingPortRegion: [],
    vesselType: [],
    vesselTypeRegion: [],
    stateRegion: [],
    supplierCountry: [],
    transportation: [],
    typeOfService: [],
    standardVoccName: [],
    weight: [],
    include_master_bill: [],
    shipmentValue: [],
    sections: [],
    shipperFacility: [],
    consigneeFacility: [],
    derivedShipperMasterName: [],
    derivedConsigneeMasterName: [],
    productCategory: [],
    industryCategory: [],
    shipperCity: [],
    sixDigitHsCode: [],
    standardLadingPortName: [],
    standardLadingPortRegion: [],
    containerDimensionRegion: [],
    containerDimension: [],
    containerDescriptionRegion: [],
    containerDescription: [],
    standardTradeLane: [],
    quantityUnit: [],
    perUnitValue: [],
    quantityRange: [],
  },
  defaultBooleanFilterObj: {
    include_master_bill: true,
    exclude_blank_consignee: false,
    exclude_blank_shipper: false,
  },
  selectAll: {
    billType: false,
    buyerCity: false,
    buyerState: false,
    buyerZipCode: false,
    carrierName: false,
    countryOfImportRegion: false,
    countryOfExportRegion: false,
    consigneeJurisdictionCountryRegion: false,
    containerType: false,
    countryRegion: false,
    equipmentDescription: false,
    exporters: false,
    is_supplier: false,
    is_buyer: false,
    isImporter: false,
    consigneeName: false,
    foreignPort: false,
    foreignPortRegion: false,
    hsCode: false,
    importers: false,
    lclFCL: false,
    vesselName: false,
    noOfUniqueContainers: false,
    notifyParty: false,
    secondaryNotifyParties: false,
    standardNvoccName: false,
    standardFreightForwarderName: false,
    portOfArrival: false,
    portOfDestination: false,
    portOfDestinationRegion: false,
    standardUnladingPortName: false,
    standardUnladingPortRegion: false,
    vesselType: false,
    vesselTypeRegion: false,
    stateRegion: false,
    supplierCountry: false,
    teu: false,
    transportation: false,
    typeOfService: false,
    standardVoccName: false,
    weight: false,
    shipmentValue: false,
    sections: false,
    derivedShipperMasterName: false,
    derivedConsigneeMasterName: false,
    productCategory: false,
    industryCategory: false,
    shipperCity: false,
    sixDigitHsCode: false,
    standardLadingPortName: false,
    standardLadingPortRegion: false,
    containerDimensionRegion: false,
    containerDescriptionRegion: false,
    shipperFacility: false,
    consigneeFacility: false,
    standardTradeLane: false,
    quantityUnit: false,
    perUnitValue: false,
    quantityRange: false,
  },
  specialMappingFields: {},
  normalfilterList: [
    { heading: "Filter by Consignee Standardized Name", categoryName: categoryType.consigneeDetails, eventKey: "27", key: "derivedConsigneeMasterName", type: filterType.normalFilter, label: "Consignee Standardized Name", viewAllPlaceHolder: "Search in Consignee Standardized Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Consignee Name", categoryName: categoryType.consigneeDetails, eventKey: "2", key: "consigneeName", type: filterType.normalFilter, label: "Consignee Name", viewAllPlaceHolder: "Search by Consignee Name", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Consignee Type", categoryName: categoryType.consigneeDetails, eventKey: "3", key: "isImporter", type: filterType.normalFilter, label: "Consignee Type", viewAllPlaceHolder: "Search in Is Importer Filter", emptyFilterText: "", searchFilterString: "", showInput: false },
    { heading: "Filter by Consignee Jurisdiction Country", categoryName: categoryType.consigneeDetails, eventKey: "7", key: "consigneeJurisdictionCountryRegion", altKey: "consigneeJurisdictionCountry", type: filterType.localizeFilter, label: "Consignee Jurisdiction Country", viewAllPlaceHolder: "Search by Consignee Jurisdiction Country", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Country of Import", categoryName: categoryType.consigneeDetails, eventKey: "25", key: "countryOfImportRegion", altKey: "countryOfImport", type: filterType.localizeFilter, label: "Country of Import", viewAllPlaceHolder: "Search Country of Import", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Country of Export", categoryName: categoryType.shipperDetails, eventKey: "25", key: "countryOfExportRegion", altKey: "countryOfExport", type: filterType.localizeFilter, label: "Country of Export", viewAllPlaceHolder: "Search Country of Export", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by HS Code", categoryName: categoryType.cargoDetails, eventKey: "13", key: "hsCode", type: filterType.hsCodeFilter, label: "HS Code", viewAllPlaceHolder: "Type to Search HS Code", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by 6 digit HS Code", categoryName: categoryType.cargoDetails, eventKey: "9", key: "sixDigitHsCode", type: filterType.normalFilter, label: "6 Digit HS Code", viewAllPlaceHolder: "Type to Search 6 digit HS Code", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Weight", categoryName: categoryType.cargoDetails, eventKey: "20", key: "weight", type: filterType.boxFilter, label: "Weight", viewAllPlaceHolder: "", emptyFilterText: "", searchFilterString: "", infoText: "", showInput: false },
    { heading: "Filter by Shipment Value (USD)", categoryName: "cargoDetails", eventKey: "25", key: "shipmentValue", type: filterType.boxFilter, label: "Shipment Value", viewAllPlaceHolder: "Search Shipment Value", emptyFilterText: "", searchFilterString: "", upgradeText: "To access Conatiner Load filters you need to upgrade to higher plan.", isTextCapitalise: true },
    { heading: "Filter by Product Category", categoryName: "cargoDetails", eventKey: "8", key: "productCategory", type: filterType.normalFilter, label: "Product Category", viewAllPlaceHolder: "Search in Product Category Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Industry Group", categoryName: "cargoDetails", eventKey: "33", key: "industryCategory", type: filterType.normalFilter, label: "Industry Group", viewAllPlaceHolder: "Search in Industry Group Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Quantity Unit", categoryName: "cargoDetails", eventKey: "32", key: "quantityUnit", additionalKey: "quantityRange", type: filterType.normalFilter, label: "Quantity", viewAllPlaceHolder: "Search Quantity Unit", emptyFilterText: "", searchFilterString: "", infoText: "", showInput: true, isParanthesesCapital: false, additionalType: "multiSelectRangeFilter" },
    { heading: "Filter by Per Unit Value (USD)", categoryName: categoryType.cargoDetails, eventKey: "32", key: "perUnitValue", type: filterType.multiSelectRangeFilter, label: "Per Unit Value (USD)", viewAllPlaceHolder: "", emptyFilterText: "", searchFilterString: "", infoText: "", showInput: false, isParanthesesCapital: false },
  ],
  internalFilterList: [
    { isVisible: true, key: "uniqueImportExporterShipment" },
    { isVisible: true, key: "uniqueImportExporterWeight" },
    { isVisible: true, key: "uniqueImportExporterValue" },
  ],
  highLightedColumnList: [
    { key: "hs_code", label: "HS Code" },
    { key: "derived_consignee_master_name", label: "Consignee Standardized Name" },
    { key: "consignee_name", label: "Consignee Name" },
    { key: "product_description", label: "Product Description" },
  ],
  shipmentSorting: [
    { columnKey: "actual_arrival_date", value: "date", isDefault: true },
    { columnKey: "derived_weight", value: "weight", isDefault: false },
    { columnKey: "derived_shipment_value", value: "shipment_value", isDefault: false },
  ],
  exporterSorting: [
    { name: "Shipments", columnKey: "doc_count", value: "date", isDefault: true },
    { name: "Weight", columnKey: "weight", value: "weight", isDefault: false },
    { name: "Shipment Value", columnKey: "shipment_value", value: "shipment_value", isDefault: false },
  ],
  importerSorting: [
    { name: "Shipments", columnKey: "doc_count", value: "date", isDefault: true },
    { name: "Weight", columnKey: "weight", value: "weight", isDefault: false },
    { name: "Shipment Value", columnKey: "shipment_value", value: "shipment_value", isDefault: false },
  ],
  sortKeyMap: {
    date: "actual_arrival_date",
    weight: "derived_weight",
    shipment_value: "derived_shipment_value",
  },
  sortKeyUniqueImpExpMap: {
    date: "doc_count",
    weight: "weight",
    shipment_value: "shipment_value",
  },
  analyticsHeaderItems: [
    { label: "Total Shipments", key: "total_shipments", valuePrefix: "", valueSuffix: "" },
    { label: "Total Shipments Weight", key: "total_weight", valueSuffix: "Kg", valuePrefix: "" },
    { label: "Total Shipments Value", key: "total_value", valueSuffix: "", valuePrefix: "USD" },
  ],
  levelTwoAnalyticsHeaderItems: {},
  analyticsFieldsMapping: [
    { key: "trade_country_of_export_to_import", filterKey1: "countryOfExportRegion", filterKey2: "countryOfImportRegion", label: "Trade Routes (Country of Export → Country of Import)", headerOne: "Country of Export", headerTwo: "Country of Import", filterOne: "filterField1", filterTwo: "filterField2", keyOne: "field1Country", keyTwo: "field2Country", cityOne: "field1", cityTwo: "field2", keyOneCountryCode: "field1CountryCode", keyTwoCountryCode: "field2CountryCode", type: analyticsType.topTwo, showTrends: true, grpType: "multi", showlevelTwo: true, defaultKey: "derived_consignee_master_name" },
    { key: "trends", filterKey: "", label: "Import Trends", type: analyticsType.trends, showTrends: true, showlevelTwo: false, modalHeader: "Import Trends" },
    { key: "country_of_export", filterKey: "countryOfExportRegion", label: "Countries of Export", type: analyticsType.horizontalCountry, showTrends: true, showlevelTwo: true, defaultKey: "derived_consignee_master_name", modalHeader: "Countries of Export" },
    { key: "hs_code", headerLabel: "HS Codes", filterKey: "hsCode", label: "2 digit HS Codes", type: analyticsType.hsCode, infoText: "Analytics data is based on the summary of the shipments obtained through a search query.<br/> Hence the data may contain aggregated results for all products, HS Codes present in the search results.", showlevelTwo: false, modalHeader: "2 digit HS Codes" },
    { key: "six_digit_hs_code", headerLabel: "6 digit HS Code", filterKey: "sixDigitHsCode", label: "6 digit HS Codes", type: analyticsType.hsCode, showTrends: true, showlevelTwo: true, defaultKey: "derived_consignee_master_name" },
  ],
  searchTableColumns: [
    { key: "", name: "View", selector: "", dataTip: "", type: "viewShipment", button: true, staticField: true, miWidth: "40px", maWidth: "40px" },
    { key: "s_no", name: "S No", selector: "s_no", dataTip: "", type: "", maxWidth: "84px !important", minWidth: "84px !important", grow: 0, wrap: true, staticField: true, miWidth: "60px", maWidth: "60px" },
    { key: "actual_arrival_date", name: "Arrival Date", selector: "actual_arrival_date", dataTip: "", type: "", dateFormat: "MMM DD, YYYY", sortable: true, grow: 0, wrap: true, miWidth: "105px", maWidth: "105px" },
    { key: "matched_column", name: "Matching Fields", selector: "matched_column", dataTip: "", type: "matchingField", grow: 1, wrap: true, miWidth: "120px", maWidth: "120px" },
    { key: "derived_hs_codes_string", name: "HS Code", maxWidth: "120px !important", minWidth: "120px !important", selector: "derived_hs_codes_string", wrap: true, isSliceEnabled: true, sliceLength: 40, alternateSelector: "derived_hs_codes_string_estimated", alternateValueCheckField: "derived_hs_codes_string_estimated_is_present", dataTip: "", type: "conditionalBlur", grow: 1, isInfoText: true, infoText: "HS Code for some shipments may be estimated based on the shipment data. For differentiation between actual and estimated HS Code please view the Shipment Details.", upgradeText: "To view estimated HS Code, you would need to upgrade to higher plan.", miWidth: "100px", maWidth: "100px" },
    { key: "derived_unique_product_keywords", name: "Product", selector: "derived_unique_product_keywords", tooltipValue: "derived_unique_product_keywords", type: "", grow: 1, wrap: true, isSliceEnabled: true, sliceLength: 40, miWidth: "120px", maWidth: "120px" },
    { key: "manifest_quantity", name: "Quantity", selector: "derived_quantity_unit", secondarySelector: "derived_quantity_unit", dataTip: "", type: "", grow: 0, wrap: true, isCommaFormat: true, fixedValueUpto: 2, miWidth: "100px", maWidth: "100px" },
    { key: "derived_weight", name: "Weight (kg)", selector: "derived_weight", dataTip: "", type: "", sortable: true, grow: 0, wrap: true, isCommaFormat: true, fixedValueUpto: 2, miWidth: "100px", maWidth: "100px" },
    { key: "derived_shipment_teu", name: "TEUs", selector: "derived_shipment_teu", valueCheckField: "derived_shipment_teu_is_present", type: "conditionalBlur", dataTip: "", sortable: true, grow: 0, wrap: true, isCommaFormat: true, fixedValueUpto: 2, upgradeText: "To view TEU, you would need to upgrade to higher plan.", miWidth: "60px", maWidth: "60px" },
    { key: "derived_consignee_master_name", name: "Consignee", selector: "derived_consignee_master_name", alternateSelector: "consignee_name", id: "derived_consignee_master_company_id", dataTip: "", type: "companyRedirect", companyType: "I", grow: 1, wrap: true, miWidth: "120px", maWidth: "120px" },
    { key: "derived_shipper_master_name", name: "Shipper Name", selector: "derived_shipper_master_name", alternateSelector: "shipper_party_name", id: "derived_shipper_master_company_id", dataTip: "", type: "companyRedirect", companyType: "E", grow: 1, wrap: true, miWidth: "120px", maWidth: "120px" },
    { key: "derived_country_of_origin", name: "Country of Export", selector: "derived_country_of_origin", dataTip: "", type: "", grow: 1, wrap: true, miWidth: "100px", maWidth: "100px" },
    { key: "derived_shipment_value", name: "Estimated Shipment Value (USD)", selector: "derived_shipment_value", valueCheckField: "derived_shipment_value_is_present", type: "conditionalBlur", dataTip: "", sortable: true, grow: 1, wrap: true, isCommaFormat: true, fixedValueUpto: 2, upgradeText: "To view estimated shipment value, you would need to upgrade to higher plan.", miWidth: "120px", maWidth: "120px" },
  ],
  importerTableColumn: [
    { key: "id", showUiUeTwoLevel: false, name: "S No.", selector: "id", dataTip: "", type: "", button: true, staticField: true },
    { key: "key", name: "Company Name", selector: "key", selector1: "country", selector1Code: "country_code", selector2: "state", selector3: "address", id: "hashed_id", type: "companyRedirect", fixedLengthUptoRank: 30, fixedLengthUptoTrend: 28, minWidth: "275px" },
    { key: "subKey", showUiUeTwoLevel: true, name: "Random Table", selector: "subKey", grow: 1, wrap: true },
    { key: "doc_count", name: "Shipments", selector: "doc_count", sortable: true, dataTip: "", type: "", grow: 1, wrap: true, isCommaFormat: true },
    { key: "weight", name: "Weight(kg)", selector: "weight", sortable: true, dataTip: "", type: "", grow: 1, wrap: true, isCommaFormat: true, fixedValueUpto: 2 },
    { key: "shipment_value", name: "Shipment Value (USD)", selector: "shipment_value", sortable: true, dataTip: "", type: "conditionalBlur", grow: 1, wrap: true, isCommaFormat: true, fixedValueUpto: 2, upgradeText: "To view Shipment, you would need to upgrade to higher plan." },
    { key: "oldest_shipment_date", name: "First Imported On", selector: "oldest_shipment_date", grow: 1, wrap: true },
    { key: "recent_shipment_date", name: "Last Imported On", selector: "recent_shipment_date", grow: 1, wrap: true },
    { key: "market_share", showUiUeTwoLevel: true, isNameVariable: true, name: "% share by", selector: "market_share", type: "", grow: 1, wrap: true },
  ],
  viewShipmentDetails: [
    {
      id: 1,
      title: "",
      growValue: 12,
      isHeader: true,
      imgUrl: "",
      data: [
        { label: "Shipment Date", value: "derived_shipment_date", dateFormat: true, monthFormat: false },
        { label: "HS Code", value: "hs_code" },
      ],
    },
    {
      id: 2,
      title: "Shipment Origin Details",
      isConnectedColumn: true,
      isCompactHeader: true,
      growValue: 6,
      isHeader: false,
      imgUrl: "",
      data: [{ label: "Country of Export", value: "derived_country_of_export", countryFlag: true, countryCodeField: "derived_country_of_export_code" }],
    },
    {
      id: 3,
      title: "Shipment Destination Details",
      growValue: 6,
      isHeader: false,
      isCompactHeader: true,
      imgUrl: "",
      data: [
        { label: "Country of Import", value: "derived_country_of_import", countryFlag: true, countryCodeField: "derived_country_of_import_code" },
        { label: "Consignee Standardized Name", type: "redirect", companyIdKey: "derived_consignee_master_company_id", companyKey: "", derivedCompanyKey: "derived_consignee_master_name" },
        { label: "Consignee Name", value: "consignee_name" },
        { label: "Consignee Type", value: "derived_is_importer" },
        { label: "Consignee Jurisdiction Country", value: "derived_consignee_jurisdiction_country", countryFlag: true, countryCodeField: "derived_consignee_jurisdiction_country_code" },
      ],
    },
    {
      id: 4,
      title: "Cargo Details",
      growValue: 6,
      isHeader: false,
      imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251778/images/website/api-integration/delivery-box_1_1_niaysj.svg",
      data: [
        { label: "Product Description", value: "product_description", isCapitalise: true },
        { label: "Quantity", value: "quantity", dynamicUnit: true, unitField: "derived_quantity_unit", isCommaFormat: true },
        { label: "Per Unit Value", value: "derived_shipment_value_usd_per_quantity_unit", valuePrefix: "USD ", isCommaFormat: true },
        { label: "Net Weight (kg)", value: "net_weight_kg", valueSuffix: " kg", isCommaFormat: true },
        { label: "Shipment Value (USD)", value: "shipment_value_usd", valuePrefix: "USD ", isCommaFormat: true },
      ],
    },
  ],
  onboardingSteps: [
    { selector: "#reacttourdaterange", disableInteraction: true, header: "", description: "Customize your search basis shipment arrival date", float: "", position: "left" },
    { selector: "#reacttourSearchToggle", disableInteraction: true, header: "Normal Search / Advance Search", description: "Use Advance search feature to refine your search", float: "right", position: "bottom" },
    { selector: "#reacttourFilter", disableInteraction: true, header: "Filters Button", description: "Use filters to get most relevant shipments for you", float: "right", position: "right" },
    { selector: "#reacttourMainSearch", disableInteraction: true, header: "Start searching for US Imports Shipments", description: "Entire Bill of Lading, HS Codes, Product Description, Buyers and Suppliers", float: "right", position: "bottom" },
    { selector: "#nav-tab", disableInteraction: true, header: "", description: "View unique consignees, shippers in the search result and add them to your prospect list.", float: "right", position: "bottom" },
    { selector: ".saved-search-button", disableInteraction: true, header: "", description: "Reload from Saved Searches, for quick shipments data access.", float: "", position: "bottom" },
  ],
  specialTooltipKeywords: {
    buyerZipCode: "Buyer Zip Code",
  },
  defaultUeUiSecondLevelKey: "country_of_export",

  twoColumnMapping: {
    trade_country_of_export_to_import: "Trade Routes (Country of Export → Country of Import)",
    derived_consignee_master_name: "Unique Importers",
    country_of_export: "Country of Export",
    six_digit_hs_code: "6 digit HS Codes",
  },
};

const EthiopiaImports = () => {
  return <Shipments defaultData={defaultData} analyticDropdownOptions={analyticDropdownOptions} trendsDropdownOptions={trendsDropdownOptions} />;
};
export default EthiopiaImports;
